<template>
	<!-- 入库 -->
	<!-- 表格 -->
	<div class="batchAdd">
		<div class="title">就诊流程_批量申请单录入</div>
		<a-table
				:scroll="{x:2370}"
				class="hospital-table"
				size="middle"
				:pagination="false"
				:rowKey="record => record.rowId"
				:dataSource="data"
		>
			<a-table-column :width="50" :customRender="(text, record, index) => `${index + 1}`">
				<span class="table-th" slot="title">序号</span>
			</a-table-column>
			<a-table-column :width="130" data-index="hosBarCode" key="hosBarCode">
				<span class="hospital-required table-th" slot="title">协作组条码</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!record.hosBarCode}">
						<a-input
								placeholder="请输入协作组条码"
								style="margin: -5px 0;width: 130px"
								v-model="record.hosBarCode"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="140" data-index="deptId" key="deptId">
				<span class="hospital-required table-th" slot="title">测序中心</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!record.deptId}">
						<a-select
								:getPopupContainer="triggerNode => triggerNode.parentNode"
								:disabled="sequencingStatus"
								style="width:100%;"
								v-model="record.deptId"
								placeholder="请选择测序中心"
						>
							<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
							<a-select-option
									:key="item.deptId"
									v-for="item in sequencingData"
									:value="item.deptId+''"
							>{{item.deptName}}
							</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="barCode" key="barCode">
				<span class="table-th hospital-required" slot="title">测序中心条码</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!record.barCode}">
						<a-input
								placeholder="请输入测序中心条码"
								style="margin: -5px 0;width: 130px"
								v-model="record.barCode"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="patientName" key="patientName">
				<span class="table-th hospital-required" slot="title">患者姓名</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!record.patientName}">
						<!-- {{isSubmit&&!record.patientName}}{{record.status}} -->
						<a-input
								placeholder="请输入患者姓名"
								style="margin: -5px 0;width: 130px"
								v-model="record.patientName"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="95" data-index="sexName" key="sexName">
				<span class="table-th hospital-required" slot="title">性别</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!record.sexName}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width:95px;"
						          v-model="record.sexName" placeholder="请选择">
							<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
							<a-select-option value="男">男</a-select-option>
							<a-select-option value="女">女</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="150" data-index="patientCardNo" key="patientCardNo">
				<span class="table-th" slot="title">身份证号</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!isCard(record.patientCardNo)}">
						<a-input
								placeholder="请输入身份证号"
								style="margin: -5px 0;width: 150px"
								v-model="record.patientCardNo"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="hospitalId" key="hospitalId">
				<span class="table-th hospital-required" slot="title">就诊医院</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!record.hospitalId}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width:130px;"
						          v-model="record.hospitalId" placeholder="请选择就诊医院">
							<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
							<a-select-option
									:key="item.deptId"
									:title="item.deptName"
									v-for="item in hospitalData"
									:value="item.deptId"
							>{{item.deptName}}
							</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="120" data-index="seeDoctorTime" key="seeDoctorTime">
				<span class="table-th" slot="title">就诊日期</span>
				<template slot-scope="text, record">
					<div
							:class="{'has-error':isSubmit&&record.rowStatus&&!isOkDate(record.seeDoctorTime)}"
					>
						<a-date-picker
								:getCalendarContainer="triggerNode => triggerNode.parentNode"
								style="width: 120px"
								placeholder="选择就诊日期"
								v-model="record.seeDoctorTime"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="patientNo" key="patientNo">
				<span class="table-th" slot="title">门诊号</span>
				<template slot-scope="text, record">
					<div>
						<a-input
								placeholder="请输入门诊号"
								style="margin: -5px 0;width: 130px"
								v-model="record.patientNo"
						/>
					</div>
				</template>
			</a-table-column>
			<!-- isOkDate -->
			<a-table-column :width="120" data-index="ageBirthDay" key="ageBirthDay">
				<span class="table-th" slot="title">出生日期</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!isOkDate(record.ageBirthDay)}">
						<a-date-picker
								:getCalendarContainer="triggerNode => triggerNode.parentNode"
								style="width: 120px" :disabledDate="disabledEndDate" placeholder="选择出生日期"
								v-model="record.ageBirthDay"/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="120" data-index="sampleCollectionTime" key="sampleCollectionTime">
				<span class="table-th" slot="title">采样日期</span>
				<template slot-scope="text, record">
					<div
							:class="{'has-error':isSubmit&&record.rowStatus&&!isOkCollectionTime(record.sampleCollectionTime,record.ageBirthDay)}"
					>
						<a-date-picker
								:getCalendarContainer="triggerNode => triggerNode.parentNode"
								style="width: 120px"
								:disabledDate="disabledEndDate"
								placeholder="选择采样日期"
								v-model="record.sampleCollectionTime"
						/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="100" data-index="applyItemName" key="applyItemName">
				<span class="table-th hospital-required" slot="title">检测项目</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!record.applyItemName}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width: 100px"
						          v-model="record.applyItemName" placeholder="请选择检测项目">
							<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
							<a-select-option
									v-for="item in applyItems"
									:key="item.dictKey"
									:value="item.dictKey"
							>{{item.dictValue}}
							</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
			<!--<a-table-column :width="130" data-index="groupName" key="groupName">-->
				<!--<span class="table-th" slot="title">专业组</span>-->
				<!--<template slot-scope="text, record">-->
					<!--<a-input-->
							<!--placeholder="请输入专业组"-->
							<!--style="margin: -5px 0;width: 130px"-->
							<!--v-model="record.groupName"-->
					<!--/>-->
				<!--</template>-->
			<!--</a-table-column>-->
			<a-table-column :width="100" data-index="sampleTypeName" key="sampleTypeName">
				<span class="table-th" slot="title">样本类型</span>
				<template slot-scope="text, record,index">
					<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width:100px"
					          v-model="record.sampleTypeName" placeholder="请选择样本类型">
						<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
						<a-select-option
								v-for="item in sampleTypes"
								:key="item.dictKey"
								:value="item.dictKey"
						>{{item.dictValue}}
						</a-select-option>
					</a-select>
				</template>
			</a-table-column>
			<a-table-column :width="140" data-index="sampleAmount" key="sampleAmount">
				<span class="table-th" slot="title">样本量(ml)限两位小数</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!isOkNum(record.sampleAmount)}">
						<a-input type="number" style="width:140px" v-model="record.sampleAmount"
						         placeholder="输入样本量（ml）"/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="clinicalDiagnosis" key="clinicalDiagnosis">
				<span class="table-th" slot="title">临床诊断</span>
				<template slot-scope="text, record">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&!isOkNum(record.clinicalDiagnosis)}">
						<a-input type="text" style="width:130px" v-model="record.clinicalDiagnosis"
						         placeholder="输入临床诊断"/>
					</div>
				</template>
			</a-table-column>
			<a-table-column :width="130" data-index="scanFlag" key="scanFlag">
				<span class="table-th hospital-required" slot="title">FQ录入方式</span>
				<template slot-scope="text, record,index">
					<div :class="{'has-error':isSubmit&&record.rowStatus&&record.scanFlag==undefined}">
						<a-select :getPopupContainer="triggerNode => triggerNode.parentNode" style="width:130px;"
						          v-model="record.scanFlag" placeholder="请选择FQ录入方式">
							<a-select-option v-if="index>0" :value="-1">同上</a-select-option>
							<a-select-option :value="0">平台录入</a-select-option>
							<a-select-option :value="1">云平台同步</a-select-option>
						</a-select>
					</div>
				</template>
			</a-table-column>
		</a-table>
		<div class="footer">
			<a-button :loading="isHttpSubmit" @click="submitData" style="width:680px" type="primary">确认</a-button>
		</div>
	</div>
</template>

<script>
  import {regAll} from "../../common/validate";
  import moment from 'moment';

  export default {
    data() {
      return {
        data: [],
        hospitalData: [],
        sequencingData: [],
        applyItems: [],
        sampleTypes: [],
        isSubmit: false,
        isHttpSubmit: false,
        formDatas: [],
        sequencingStatus: false
      };
    },
    mounted() {
      this.gethospital();
      this.getDirt("sampleType").then(data => {
        this.sampleTypes = data.rows;// 样本类型
      });
      this.getDirt("applyItem").then(data => {
        this.applyItems = data.rows;// 检测项目
      });
    },
    methods: {
      moment,
      disabledEndDate(current) {
        return current && current > moment().endOf('day');
      },
      isCard(patientCardNo) {
        if (patientCardNo && !regAll.regCardNo.test(patientCardNo)) {
          return false;
        } else {
          return true;
        }
      },
      isOkNum(num) {
        if (num && !regAll.regNum2.test(num)) {
          return false;
        } else {
          return true;
        }
      },
      isOkDate(date) {
        if (date) {
          let currentDate = new Date(date.format("YYYY-MM-DD")).getTime();
          return (
            currentDate < new Date().getTime() ||
            currentDate == new Date().getTime()
          );
        } else {
          return true;
        }
      },
      isOkCollectionTime(date, ageBirthDay) {
        if (date) {
          let currentDate = new Date(date.format("YYYY-MM-DD")).getTime();
          if (ageBirthDay) {
            let ageBirthDate = new Date(
              ageBirthDay.format("YYYY-MM-DD")
            ).getTime();
            return (
              (currentDate < new Date().getTime() ||
                currentDate == new Date().getTime()) &&
              (currentDate > ageBirthDate || currentDate == ageBirthDate)
            );
          } else {
            return (
              currentDate < new Date().getTime() ||
              currentDate == new Date().getTime()
            );
          }
        } else {
          return true;
        }
      },
      initData() {
        this.data = [];
        let mockData = {
          rowId: "",
          hosBarCode: "",
          barCode: "",
          patientName: "",
          hospitalId: undefined,
          patientCardNo: "",
          sexName: undefined,
          sampleAmount: "",
          patientNo: "",
          deptId: undefined,
          ageBirthDay: undefined,
          applyItemName: undefined,
          sampleCollectionTime: undefined,
          seeDoctorTime: undefined,
          sampleTypeName: undefined,
          rowStatus: false
        };
        for (let i = 0; i < 10; i++) {
          if (i != 0) {
            mockData.sampleTypeName = -1;
            mockData.sexName = -1;
            mockData.hospitalId = -1;
            mockData.applyItemName = -1;
            mockData.deptId = -1;
          } else {
            if (this.sequencingStatus) {
              const userInfo = this.$db.get("userInfo");
              mockData.deptId = userInfo.deptId + "";
            }
          }
          mockData.rowId = i;
          this.data.push(Object.assign({}, mockData));
        }
      },
      checkRowData(data) {
        this.formDatas = [];
        this.data.forEach(item => {
          item.rowStatus = false;
          var rowStatus = true;
          if (
            item.hosBarCode.trim() != "" ||
            item.barCode.trim() != "" ||
            item.patientName.trim() != "" ||
            item.patientCardNo.trim() != "" ||
            item.sampleAmount.trim() != ""
          ) {
            rowStatus = false;
          }
          if (
            (item.sampleTypeName != -1 && item.sampleTypeName != undefined) ||
            (item.sexName != -1 && item.sexName != undefined) ||
            (item.applyItemName != -1 && item.applyItemName != undefined) ||
            (item.hospitalId != -1 && item.hospitalId != undefined) ||
            (item.deptId != -1 && item.deptId != undefined)
          ) {
            rowStatus = false;
          }
          if (!rowStatus) {
            item.rowStatus = true;
            var formObj = {};
            for (let keyName in item) {
              if (keyName != "rowId" && keyName != "rowStatus") {
                formObj[keyName] = item[keyName];
              }
            }
            this.formDatas.push(formObj);
          }
        });
      },
      submitData() {
        this.checkRowData();
        this.isSubmit = true;
        if (this.formDatas.length == 0) {
          this.$message.warning("请输入内容");
          return;
        }
        this.$nextTick(() => {
          var errList = document.querySelectorAll(".has-error");
          if (errList.length == 0) {
            let _currentItem = {
              sampleTypeName: "",
              sexName: "",
              applyItemName: "",
              hospitalId: "",
              scanFlag: "",
            };
            this.formDatas.forEach(item => {
              if (item.ageBirthDay) {
                item.ageBirthDay = item.ageBirthDay.format("YYYY-MM-DD");
              }
              if (item.sampleCollectionTime) {
                item.sampleCollectionTime = item.sampleCollectionTime.format(
                  "YYYY-MM-DD"
                );
              }
              if (item.seeDoctorTime) {
                item.seeDoctorTime = item.seeDoctorTime.format(
                  "YYYY-MM-DD"
                );
              }
              // 检查sampleTypeName是否为-1
              _currentItem.sampleTypeName = item.sampleTypeName != -1 ? item.sampleTypeName : _currentItem.sampleTypeName;
              item.sampleTypeName = item.sampleTypeName == -1 ? _currentItem.sampleTypeName : item.sampleTypeName;
              // 检查sexName是否为-1
              _currentItem.sexName = item.sexName != -1 ? item.sexName : _currentItem.sexName;
              item.sexName = item.sexName == -1 ? _currentItem.sexName : item.sexName;
              // 检查FQ录入方式是否为-1
              _currentItem.scanFlag = item.scanFlag != -1 ? item.scanFlag : _currentItem.scanFlag;
              item.scanFlag = item.scanFlag == -1 ? _currentItem.scanFlag : item.scanFlag;
              // 检查applyItemName是否为-1
              _currentItem.applyItemName =
                item.applyItemName != -1
                  ? item.applyItemName
                  : _currentItem.applyItemName;
              item.applyItemName =
                item.applyItemName == -1
                  ? _currentItem.applyItemName
                  : item.applyItemName;
              // 检查hospitalId是否为-1
              _currentItem.hospitalId =
                item.hospitalId != -1 ? item.hospitalId : _currentItem.hospitalId;
              item.hospitalId =
                item.hospitalId == -1 ? _currentItem.hospitalId : item.hospitalId;
              // 检查deptId是否为-1
              _currentItem.deptId =
                item.deptId != -1 ? item.deptId : _currentItem.deptId;
              item.deptId = item.deptId == -1 ? _currentItem.deptId : item.deptId;
            });
            this.isHttpSubmit = true;
            this.$post("patientitem/patientItem/bacth", this.formDatas, {
              "Content-Type": "application/json"
            }).then(
              res => {
                if (res.data.code == 1) {
                  this.$message.success("就诊流程 _申请单录入成功!");
                  this.$emit("close");
                } else {
                  this.isHttpSubmit = false;
                  this.$message.error(res.data.message);
                }
              },
              error => {
                this.isHttpSubmit = false;
                this.$message.error(
                  error.response.data.message || "就诊流程 _申请单录入失败!"
                );
              }
            );
          }
        });
      },
      gethospital() {
        this.$get("dept/findDeptTreeList", {
          pageSize: 10000,
          deptType: 1
        }).then(res => {
          this.hospitalData = res.data.data[0].children;
        });
        this.$get("dept/findDeptTreeList", {
          pageSize: 10000,
          deptType: 2
        }).then(res => {
          const userInfo = this.$db.get("userInfo");
          this.sequencingData = res.data.data[0].children;
          if (userInfo.deptId == null) {
            this.sequencingStatus = false;
          } else {
            this.sequencingData.forEach(item => {
              if (item.deptId == userInfo.deptId) {
                this.sequencingStatus = true;
              }
            });
          }
          this.initData();
        });
      },
      getDirt(dictType) {
        return new Promise((resolve, reject) => {
          this.$get("info/commonDict", {
            dictType: dictType,
            pageSize: 10000
          }).then(
            res => {
              resolve(res.data.data);
            },
            err => {
              reject(err);
            }
          );
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
	.batchAdd {
		.title {
			padding: 82px 0 56px 0;
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}
	}

	.table-th {
		color: #a4a4a4;
	}

	.footer {
		padding: 40px 0;
		text-align: center;
	}
</style>